import type { CmlContentInput as GraphQLCmlContentInput } from '__generated__/graphql-types';

import type { CmlContent } from 'bundles/cml';
import { CMLUtils } from 'bundles/cml';
import type { SharedPortfolioProject_UserPortfolioProject_CmlContentFragment as PortfolioProjectGraphqlCmlContent } from 'bundles/portfolio-projects/queries/__generated__/SharedPortfolioProject_UserPortfolioProject';
import type { Nullable } from 'bundles/portfolio-projects/types';

const CML_DTDID = 'project/1';

export const emptyCml = (): CmlContent => CMLUtils.create(undefined, CML_DTDID);

export const convertToCmlContent = (cml: PortfolioProjectGraphqlCmlContent): CmlContent => ({
  typeName: 'cml',
  definition: {
    dtdId: cml.dtdId,
    value: cml.cmlValue,
    renderableHtmlWithMetadata: {
      // @ts-expect-error - htmlWithMetadata is unused in our application
      metadata: cml?.htmlWithMetadata?.metadata,
      // @ts-expect-error - htmlWithMetadata is unused in our application
      renderableHtml: cml?.htmlWithMetadata?.html,
    },
  },
});

export const convertToCmlContentInput = (cml: CmlContent): GraphQLCmlContentInput => ({
  dtdId: CML_DTDID,
  cmlValue: CMLUtils.getValue(cml),
});

export const getCmlContentLength = (cml: CmlContent): number => CMLUtils.getLength(cml);

export const isEmpty = (cml: CmlContent): boolean => getCmlContentLength(cml) < 1;

export const safeConvertToCmlContentInput = (content: CmlContent) =>
  isEmpty(content) ? null : convertToCmlContentInput(content);

export const safeConvertToCmlContent = (content?: Nullable<PortfolioProjectGraphqlCmlContent>) =>
  content ? convertToCmlContent(content) : emptyCml();

export const isCmlContent = (value: CmlContent | string): value is CmlContent => CMLUtils.isCML(value);
